import { useCreateNewPassword } from "@/hooks/query-hooks/useAuth";
import { Button, Form, Input } from "antd";
import { AiOutlineLock } from "react-icons/ai";

export function AskNewPassword() {

    const [form] = Form.useForm();

    const { mutate, isMutating } = useCreateNewPassword();

    const onFinish = (values: { password: string }) => {
        mutate(values.password, {
            onSuccess: () => {
                form.resetFields();
            },
        });
    };

    return (
        <>
            <article
                className="font-poppins space-y-2"
            >
                <h3
                    className="text-lg font-medium text-center"
                >
                    Create New Password
                </h3>
                <p className="text-sm text-center text-gray-600">
                    Please enter your new password to reset your account.
                </p>
            </article>
            <Form
                form={form}
                onFinish={onFinish}
                layout="vertical"
            >
                <Form.Item
                    name="password"
                    label="Password"
                    rules={[{ required: true, message: "Please input your new password!" }]}
                >
                    <Input.Password
                        prefix={
                            <AiOutlineLock
                                className="mr-2"
                            />
                        }
                        size="large"
                        placeholder="Enter your new password"
                    />
                </Form.Item>
                <Form.Item
                    name="confirmPassword"
                    label="Confirm Password"
                    rules={[
                        {
                            required: true,
                            message: "Please input your new password!"
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue("password") === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error("The two passwords that you entered do not match!"));
                            }
                        })
                    ]}
                >
                    <Input.Password
                        prefix={
                            <AiOutlineLock
                                className="mr-2"
                            />
                        }
                        size="large"
                        placeholder="Confirm your new password"
                    />
                </Form.Item>

                <Button
                    block
                    size="large"
                    htmlType="submit"
                    className="bg-primary-gradient !text-white !font-poppins"
                    loading={isMutating}
                >
                    Create New Password
                </Button>
            </Form>
        </>
    )
}
